import * as React from 'react';
import { Flex } from '@apia/theme';
import { FaExclamationCircle } from '@meronex/icons/fa';

export interface ITooltipHelp {
  show: boolean;
  children: React.ReactNode;
  asText?: boolean;
}

const TooltipHelp = ({
  show,
  children,
  asText = false,
}: ITooltipHelp): JSX.Element | null => {
  if (!show || asText) return null;
  return show && children && !asText ? (
    <Flex
      sx={{
        width: '100%',
        pt: '2',
        pb: '3',
        alignSelf: 'baseline',
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
      className="tooltipHelp"
    >
      <Flex
        sx={{
          mr: '2',
          flex: 'none',
          color: 'palette.text.primary',
        }}
      >
        <FaExclamationCircle />
      </Flex>
      {children}
    </Flex>
  ) : null;
};

export default TooltipHelp;
